
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Das sind die Corona-Hotspots der ersten, zweiten und dritten Welle`}</h1>
    <h2>{`Neue Daten des Bundesamts für Gesundheit zeigen, welche Gemeinden besonders betroffen sind. Erkennbar sind deutliche Muster.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;